import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common'
import * as moment from 'moment';

@Injectable()
export class DatetimeService {

  constructor(private datePipe: DatePipe) { }
  //truyen vao ngay bat dau (datetime), so ngay muon tru, tra ve ngay hop le
  addDateTime(ngayBatDau, soNgayTru) {
    var dateOffset = (24 * 60 * 60 * 1000) * soNgayTru; //5 days
    var result = ngayBatDau.getTime() + dateOffset;
    return result;
  }

  //tu date chuyen thanh string dinh dang dd/mm/yyyy 00:00:00
  convertDatetoDateString(dateInput) {
    var date = new Date(dateInput);
    let _return = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "/" + ((date.getMonth() + 1) < 10 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1)) + "/" + date.getFullYear() + " 00:00:00";
    return _return;
  }
  //tu date chuyen thanh string dinh dang dd/mm/yyyy hh24:mm
  convertDatetoDateTimeString(dateInput) {
    var date = new Date(dateInput);
    let _return = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "/" + ((date.getMonth() + 1) < 10 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1)) + "/" + date.getFullYear() + " "
      + date.getHours() + ":" + (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes());
    return _return;
  }

  //tu date chuyen thanh string dinh dang hh24:mi
  convertDatetoTimeString(dateInput) {
    var date = new Date(dateInput);
    let _return = date.getHours() + ":" + (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + ":" + (date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds())
    return _return;
  }

  //tu date chuyen thanh string dinh dang dd/mm/yyyy
  convertDatetoDateOnlyString(dateInput) {
    var date = new Date(dateInput);
    let _return = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "/" + ((date.getMonth() + 1) < 10 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1)) + "/" + date.getFullYear();
    return _return;
  }

  convertMMDDYYYYToDDMMYYYY(dateInput) {
    let dateSplit = dateInput.split('/');
    return "01" + "/" + dateSplit[0] + "/" + dateSplit[2];
  }
  convertDateToMMDDYYYY(dateInput) {
    var date = new Date(dateInput);
    let _return = ((date.getMonth() + 1) < 10 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1)) + "/" + (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + "/" + date.getFullYear();
    return _return;
  }

  convertDatetoMonthOnlyString(dateInput) {
    var date = new Date(dateInput);
    let _return = "01/" + ((date.getMonth() + 1) < 10 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1)) + "/" + date.getFullYear();
    return _return;
  }

  // tinh khoang canh giua 2 
  calculateTwoDate(dateInput1, dateInput2) {
    var date1 = new Date(dateInput1);
    var date2 = new Date(dateInput2);
    let result = (date1.getTime() - date2.getTime()) / (24 * 60 * 60 * 1000);
    return result + 1;
  }
  //so sanh 2 ngay voi nhau, tra ve 1 neu lon hon; -1 neu nho hon, 0 la bang nhau
  compareTwoDate(dateInput1: Date, dateInput2: Date) {
    var date1 = new Date(dateInput1.getFullYear(), (dateInput1.getMonth() + 1), dateInput1.getDate(), 0, 0, 0, 0);
    var date2 = new Date(dateInput2.getFullYear(), (dateInput2.getMonth() + 1), dateInput2.getDate(), 0, 0, 0, 0);
    if (date1 < date2) {
      return -1
    }
    else if (date1 > date2) {
      return 1;
    }
    else {
      return 0;
    }

  }


  strToDatetime(datetime: string, format: string) {
    if (datetime == '' || datetime == null)
      return '';
    let d = moment(datetime, format);
    return d.toDate();
  }
  strToDate(_date, _format, _delimiter) {
    //stringToDate("17/9/2014","dd/MM/yyyy","/");
    var formatLowerCase = _format.toLowerCase();
    var formatItems = formatLowerCase.split(_delimiter);
    var dateItems = _date.split(_delimiter);
    var monthIndex = formatItems.indexOf("mm");
    var dayIndex = formatItems.indexOf("dd");
    var yearIndex = formatItems.indexOf("yyyy");
    var month = parseInt(dateItems[monthIndex]);
    month -= 1;
    var formatedDate = new Date(dateItems[yearIndex], month, dateItems[dayIndex]);
    return formatedDate;
  }


  getListTime(hasAll) {
    let lst_time = [];
    if (hasAll == 2)
    lst_time = [{ label: 'MAX', value: '-1' }]
    if (hasAll == 1)
      lst_time = [{ label: 'Tất cả', value: '' }]
    lst_time = lst_time.concat(
      [
        { label: '00:00', value: '00:00' },
        { label: '00:30', value: '00:30' },
        { label: '01:00', value: '01:00' },
        { label: '01:30', value: '01:30' },
        { label: '02:00', value: '02:00' },
        { label: '02:30', value: '02:30' },
        { label: '03:00', value: '03:00' },
        { label: '03:30', value: '03:30' },
        { label: '04:00', value: '04:00' },
        { label: '04:30', value: '04:30' },
        { label: '05:00', value: '05:00' },
        { label: '05:30', value: '05:30' },
        { label: '06:00', value: '06:00' },
        { label: '06:30', value: '06:30' },
        { label: '07:00', value: '07:00' },
        { label: '07:30', value: '07:30' },
        { label: '08:00', value: '08:00' },
        { label: '08:30', value: '08:30' },
        { label: '09:00', value: '09:00' },
        { label: '09:30', value: '09:30' },
        { label: '10:00', value: '10:00' },
        { label: '10:30', value: '10:30' },
        { label: '11:00', value: '11:00' },
        { label: '11:30', value: '11:30' },
        { label: '12:00', value: '12:00' },
        { label: '12:30', value: '12:30' },
        { label: '13:00', value: '13:00' },
        { label: '13:30', value: '13:30' },
        { label: '14:00', value: '14:00' },
        { label: '14:30', value: '14:30' },
        { label: '15:00', value: '15:00' },
        { label: '15:30', value: '15:30' },
        { label: '16:00', value: '16:00' },
        { label: '16:30', value: '16:30' },
        { label: '17:00', value: '17:00' },
        { label: '17:30', value: '17:30' },
        { label: '18:00', value: '18:00' },
        { label: '18:30', value: '18:30' },
        { label: '19:00', value: '19:00' },
        { label: '19:30', value: '19:30' },
        { label: '20:00', value: '20:00' },
        { label: '20:30', value: '20:30' },
        { label: '21:00', value: '21:00' },
        { label: '21:30', value: '21:30' },
        { label: '22:00', value: '22:00' },
        { label: '22:30', value: '22:30' },
        { label: '23:00', value: '23:00' },
        { label: '23:30', value: '23:30' },
      ]);
    return lst_time;
  }
  getListTimeCSKH() {
    let lst_time = [
      { label: 'Tất cả', value: '' },
      { label: '00:00', value: '00:00' },
      { label: '00:30', value: '00:30' },
      { label: '01:00', value: '01:00' },
      { label: '01:30', value: '01:30' },
      { label: '02:00', value: '02:00' },
      { label: '02:30', value: '02:30' },
      { label: '03:00', value: '03:00' },
      { label: '03:30', value: '03:30' },
      { label: '04:00', value: '04:00' },
      { label: '04:30', value: '04:30' },
      { label: '05:00', value: '05:00' },
      { label: '05:30', value: '05:30' },
      { label: '06:00', value: '06:00' },
      { label: '06:30', value: '06:30' },
      { label: '07:00', value: '07:00' },
      { label: '07:30', value: '07:30' },
      { label: '08:00', value: '08:00' },
      { label: '08:30', value: '08:30' },
      { label: '09:00', value: '09:00' },
      { label: '09:30', value: '09:30' },
      { label: '10:00', value: '10:00' },
      { label: '10:30', value: '10:30' },
      { label: '11:00', value: '11:00' },
      { label: '11:30', value: '11:30' },
      { label: '12:00', value: '12:00' },
      { label: '12:30', value: '12:30' },
      { label: '13:00', value: '13:00' },
      { label: '13:30', value: '13:30' },
      { label: '14:00', value: '14:00' },
      { label: '14:30', value: '14:30' },
      { label: '15:00', value: '15:00' },
      { label: '15:30', value: '15:30' },
      { label: '16:00', value: '16:00' },
      { label: '16:30', value: '16:30' },
      { label: '17:00', value: '17:00' },
      { label: '17:30', value: '17:30' },
      { label: '18:00', value: '18:00' },
      { label: '18:30', value: '18:30' },
      { label: '19:00', value: '19:00' },
      { label: '19:30', value: '19:30' },
      { label: '20:00', value: '20:00' },
      { label: '20:30', value: '20:30' },
      { label: '21:00', value: '21:00' },
      { label: '21:30', value: '21:30' },
      { label: '22:00', value: '22:00' },
      { label: '22:30', value: '22:30' },
      { label: '23:00', value: '23:00' },
      { label: '23:30', value: '23:30' },
    ];
    return lst_time;
  }


}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/common/datetime.service.ts